import { getProviderOAuthUrl } from "../../../../api/providers";
import SharedProviderConnectionCard from "@photon/chat-react/provider-connection-card";

const ProviderConnectionCard = ({ requirement, userId, orgId, chatId, spaceId }) => {
  const connect = async (connectionRequirement) => {
    const authorizationUrl = await getProviderOAuthUrl(
      connectionRequirement.provider_id,
      userId,
      orgId,
      spaceId
        ? { returnTo: "space_chat", chatId, spaceId }
        : { returnTo: "spark", chatId }
    );
    window.location.href = authorizationUrl;
  };

  return <SharedProviderConnectionCard requirement={requirement} onConnect={connect} />;
};

export default ProviderConnectionCard;